export enum AllocationCheckColumnId {
  SUBFIRM = 'subfirm',
  INSTRUMENT_ID = 'instrument_id',
  ORDER_SIDE = 'order_side',
  ACCOUNT_ID = 'account_id',
  LIMIT_PRICE = 'limit_price',
  QUANTITY = 'quantity',
  SETTLEMENT_DATE = 'settlementDate',
  NET_MONEY = 'net_money',
  VALIDATION_STATUS = 'validation_status',
  REJECT_REASON = 'reject_reason',
  ACTION_COLUMN = 'action_column',
}
